import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import CustomPhoneInput from '../Utilities/CustomPhoneInput';
import CustomSelect from '../Utilities/CustomSelect';
import { EditClientInfoVM } from '../../Structure/ViewModels/Trainee/EditClientInfoVM';

const EditClientInfo = (props:{id:string}) => {
    const [vm , setVm] = useState<{viewModel:EditClientInfoVM}>({viewModel:new EditClientInfoVM(props.id)})
    const control = vm .viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.loadData()
    },[])
  return (
    <div className='p-0 m-0'>
        {
            control.Show(
                <Container>
                <Row className='py-5'>
                    <h3 className='fw-bold text-center txt-color-I'> تعديل البيانات الشخصية </h3>
                </Row>
                <Row>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="ar-name" className='my-auto py-2 py-md-0'>الاسم عربي</label>
                            </Col>
                            <Col md={8}>
                                <input id='ar-name' type="text" autoComplete='off' className='w-100 input-field' value={control.Data.arabic_name} onChange={a=>control.ArabicName=a.target.value} placeholder='الاسم عربي...' />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="en-name" className='my-auto py-2 py-md-0'>الاسم انجليزي</label>
                            </Col>
                            <Col md={8}>
                                <input id='en-name' type="text" autoComplete='off' className='w-100 input-field' value={control.Data.english_name} onChange={a=>control.EnglishName=a.target.value}  placeholder='الاسم انجليزي...' />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="email" className='my-auto py-2 py-md-0'>الايميل</label>
                            </Col>
                            <Col md={8}>
                                <input id='email' type="text" autoComplete='off' className='w-100 input-field'  value={control.Data.email} onChange={a=>control.Email=a.target.value}  placeholder='الايميل ...' />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label className='my-auto py-2 py-md-0'>الموبايل</label>
                            </Col>
                            <Col md={8}>
                                <CustomPhoneInput className='input-field' countryKey={control.Data.dial_code} setCountryKey={a=>control.DialCode=a} value={control.Data.mobile} setNumber={a=>control.Mobile =a}  placeholder='الموبايل...' />    
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="nationality" className='my-auto py-2 py-md-0'>رقم الهوية</label>
                            </Col>
                            <Col md={8}>
                                <input id='nationality' type="text" autoComplete='off' className='w-100 input-field' value={control.Data.national_id} onChange={a=>control.NationalId=a.target.value}  placeholder='رقم الهوية...' />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="nationality" className='my-auto py-2 py-md-0'>صورة الهوية</label>
                            </Col>
                            <Col md={8}>
                                <input id='nationality' type="file" accept='image/*,application/pdf' className='w-100' onChange={a=>control.NationalIdImg= a.target.files?a.target.files[0]:null}  placeholder='صورة الهوية...' />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="nationality" className='my-auto py-2 py-md-0'>الجنسية</label>
                            </Col>
                            <Col md={8}>
                                <input id='nationality' type="text" autoComplete='off' className='w-100 input-field' value={control.Data.nationality} onChange={a=>control.Nationality=a.target.value}  placeholder='الجنسية...' />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="birth-date" className='my-auto py-2 py-md-0'>تاريخ الميلاد</label>
                            </Col>
                            <Col md={8}>
                                <input id='birth-date' type="date" className='w-100 input-field text-center'  value={control.Data.birth_date} onChange={a=>control.BirthDate=a.target.value}  />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="address" className='my-auto py-2 py-md-0'>العنوان</label>
                            </Col>
                            <Col md={8}>
                                <input id='address' type="text" autoComplete='off' className='w-100 input-field'  value={control.Data.address} onChange={a=>control.Adress=a.target.value}  placeholder='العنوان...' />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="marketier" className='my-auto py-2 py-md-0'>المسوق</label>
                            </Col>
                            <Col md={8}>
                                <CustomSelect list={control.Marketers} selected={control.Data.marketer_id} clearable={false} onSelect={a=>control.MarketerId=a} />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                        <Row  className='w-100'>
                            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                                <label htmlFor="marketier" className='my-auto py-2 py-md-0'>النوع</label>
                            </Col>
                            <Col md={8}>
                                <CustomSelect clearable={false} list={[{label:'ذكر' , value:'1'} , {label:'انثى' , value:'0'}]} selected={control.Data.is_male?'1':'0'} onSelect={a=>control.IsMale=a==='1'?true:false} />
                            </Col>
                        </Row>
                    </Col>
                    </Row>
                    <Row className=' justify-content-center py-3'>
                        <Col lg={12} className='d-flex justify-content-center px-3 py-5'>
                            <button className='button-I btn-cl-I mx-3 p-1 px-5 fs-5 ' onClick={()=>control.send()}>حفظ</button>
                        </Col>
                    </Row>
            </Container>
            )
        }
    </div>

  )
}

export default EditClientInfo
